// import logo from './logo.svg';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import { createContext, useRef } from 'react';
import './App.css';
import { AuthProvider } from './Shared/Context/AuthContext';
import Layout from './Shared/Layout';
// import { useCalendarLocale } from './Shared/hook/useCalendarLocale';

export const ToastContext = createContext<any>(null);

function App() {
// useCalendarLocale();
const toast = useRef<Toast>(null);
  return (
    <div className="App">
      <AuthProvider>
         <ToastContext.Provider value={toast}>
            <Toast ref={toast} />
            <Layout></Layout>
         </ToastContext.Provider>
          <ConfirmDialog />
      </AuthProvider>
    </div>
  );
}

export default App;
